import React from 'react';

const LoserModal = ({ 
  show, 
  winners = [], 
  currentPlayer = '', 
  finalScore = 0,
  onPlayAgain, 
  onBackToLobby, 
  onClose 
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 backdrop-blur-sm overflow-y-auto p-2 sm:p-4">
      <div className="relative w-full max-w-sm sm:max-w-lg md:max-w-md bg-black/60 backdrop-blur-md rounded-xl sm:rounded-2xl md:rounded-3xl shadow-2xl border border-white/20 max-h-[95vh] overflow-y-auto overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-3 sm:p-4 border-b border-white/20">
          <h2 className="text-lg sm:text-xl uppercase text-white">💀 Game Over</h2>
          <button 
            className="p-2 text-white/70 hover:text-white hover:bg-white/10 rounded-full transition-all duration-200"
            onClick={onClose}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        {/* Content */}
        <div className="p-3 sm:p-4 ">
          <div className="text-center">
            {/* Loser Animation */}
            <div className="mb-4 sm:mb-6 md:mb-8">
              <div className="inline-flex items-center justify-center w-12 h-12  mb-3 sm:mb-4 md:mb-6 bg-gradient-to-r from-red-500 to-pink-600 rounded-full shadow-2xl">
                <svg className="w-8 h-8  text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </div>
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-pink-500 mb-2 sm:mb-3 md:mb-4">
                You Lost! 😔
              </h3>
              <p className="text-sm sm:text-base  text-white/90 mb-4 sm:mb-6 md:mb-8 px-2">
                Better luck next time! Keep practicing and you'll get them next round!
              </p>
            </div>

            {/* Loser Details */}
            <div className="bg-gradient-to-r from-red-500/20 to-pink-600/20 backdrop-blur-sm rounded-lg sm:rounded-xl md:rounded-2xl p-3 sm:p-4  mb-4 sm:mb-6 md:mb-8 border border-red-500/30">
              <div className="space-y-2 sm:space-y-3 md:space-y-4">
                <div className="flex items-center justify-center space-x-2 sm:space-x-3">
                  <span className="text-xl sm:text-2xl md:text-3xl">💀</span>
                  <div>
                    <span className="text-white/70 text-xs text-left sm:text-sm block">Eliminated</span>
                    <p className="text-white font-bold text-base sm:text-lg">{currentPlayer}</p>
                  </div>
                </div>
                
                <div className="flex items-center justify-center space-x-2 sm:space-x-3">
                  <span className="text-xl sm:text-2xl md:text-3xl">⭐</span>
                  <div>
                    <span className="text-white/70 text-xs text-left sm:text-sm block">Final Score</span>
                    <p className="text-white font-bold text-base sm:text-lg md:text-xl ">{finalScore} points</p>
                  </div>
                </div>

                {winners.length > 0 && (
                  <div className="mt-3 sm:mt-4 pt-3 sm:pt-4 border-t border-white/20">
                    <span className="text-white/70 text-xs sm:text-sm block mb-1 sm:mb-2">Winner(s):</span>
                    <p className="text-white font-semibold text-sm sm:text-base md:text-lg">{winners.join(', ')}</p>
                  </div>
                )}
              </div>
            </div>

            {/* Elimination Badge */}
            <div className="flex justify-center mb-4 sm:mb-6 md:mb-8">
              <span className="inline-flex items-center px-3 sm:px-4 md:px-6 lg:px-8 py-2 sm:py-3 md:py-2 bg-gradient-to-r from-red-500 to-pink-600 text-white font-bold text-sm  rounded-full shadow-lg">
                <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 lg:w-8 lg:h-8 mr-1 sm:mr-2 md:mr-3" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
                ELIMINATED 💀
              </span>
            </div>

            {/* Encouragement Message */}
            <div className="bg-white/10 backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 mb-4 sm:mb-6 md:mb-8 border border-white/20">
              <p className="text-white/80 text-xs">
                💪 Don't give up! Every champion was once a beginner. 
                <br className="hidden md:block" />
                <span className="md:hidden"> </span>
                🎯 Practice makes perfect - try again!
              </p>
            </div>
          </div>
          
          {/* Action Buttons */}
          <div className="flex flex-row gap-2 sm:gap-3 md:gap-4">
            <a 
              href="/game-lobby/lobby"
              onClick={onPlayAgain}
              className="flex items-center justify-center space-x-2 sm:space-x-3 px-3 py-3 sm:py-3 md:py-4 bg-gradient-to-r from-cyan-400 to-blue-500 text-white font-bold  text-sm rounded-lg md:rounded-xl shadow-lg hover:shadow-xl active:scale-95 transition-all duration-200 w-full no-underline"
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              <span>Play Again</span>
            </a>
            
            <a 
              href="/game-lobby/lobby"
              onClick={onBackToLobby}
              className="flex items-center justify-center space-x-2 sm:space-x-3 px-3 py-3 sm:py-3 md:py-4 bg-white/20 backdrop-blur-sm text-white font-bold  text-sm rounded-lg md:rounded-xl border border-white/30 hover:bg-white/30 active:scale-95 transition-all duration-200 w-full no-underline"
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              <span>Back to Lobby</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoserModal;
